import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { MechanismReveal } from './components/MechanismReveal';
import { OfferStack } from './components/OfferStack';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { ReviewSection } from './components/ReviewSection';
import { FinalCTA } from './components/FinalCTA';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-navy-900 selection:bg-gold selection:text-navy-900 pt-12" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <MechanismReveal data-id="element-3" />
      <OfferStack data-id="element-4" />
      <Guarantee data-id="element-5" />
      <Pricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <ReviewSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <FAQ data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchaseNotification data-id="element-12" />
    </main>;
}